<table>
	<thead>
		<th>{{ 'CONTACT.NAME' | translate }}</th>
		<th>{{ 'CONTACT.QTD' | translate }}</th>
		<th>{{ 'CONTACT.LAST_SESSION' | translate }}</th>
		<th>{{ 'CONTACT.STATUS' | translate }}</th>
		<th>{{ 'CONTACT.ACTIONS' | translate }}</th>
	</thead>
	<tbody *ngIf="!loading" [ngClass]="{ 'tbody--empty': contacts.length === 0 }">
		<ng-container *ngIf="contacts.length > 0">
			<tr *ngFor="let contact of contacts">
				<td>
					<div class="zk-flex zk-gap-2 zk-items-center">
						<div freud-tooltip
						[tooltipLabel]="
							contact.refUserId === null
								? 'Contato não pode ser selecionado, pois ainda não é cliente Zenklub.'
								: ''">
							<freud-checkbox
								[disabled]="contact.refUserId === null"
								[ngClass]="{'checkbox-no-refUserId': contact.refUserId === null}"
								[(ngModel)]="contact.isSelected"
								(onChange)="
									onToggleContact.emit({
										checked: $event.checked,
										refUserId: contact.refUserId
									})
								"
							></freud-checkbox>
						</div>
						<span
							class="zk-mt-1 zk-pointer"
							(click)="goToProfile(contact.id)"
							tabindex="0"
							(keyup.enter)="goToProfile(contact.id)"
						>
							{{ contact.displayName }}
						</span>
						<div
							*ngIf="isTodayBirthday(contact.birthday)"
							freud-tooltip
							[tooltipLabel]="'CONTACT.BIRTHDAY' | translate"
							tooltipPosition="right"
						>
							<span class="freud-icon freud-icon-ballon"></span>
						</div>
					</div>
				</td>
				<td (click)="goToProfile(contact.id)">
					{{ contact.refUserId ? contact.totalSessions : '--' }}
				</td>
				<td (click)="goToProfile(contact.id)">
					<div class="zk-flex zk-gap-2 zk-items-center">
						<span>{{ formatDate(contact.lastEventDate) }}</span>
						<div
							*ngIf="contact.hasPendingPromptuaries"
							freud-tooltip
							[tooltipLabel]="'CONTACT.PENDENCIES' | translate"
							tooltipPosition="right"
						>
							<span class="freud-icon freud-icon-exclamation-circle"></span>
						</div>
					</div>
				</td>
				<td>
					<freud-select
						class="table__status-select"
						[placeholder]="'CONTACT.SELECT' | translate"
						optionValue="value"
						[options]="statusOptions"
						[ngModel]="contact.status"
						(onChange)="onChangeStatus(contact.id, $event)"
					></freud-select>
				</td>

				<td>
					<div class="table__actions">
						<button
							(click)="contact.refUserId !== null && openChat(contact)"
							[disabled]="contact.refUserId === null"
							freud-tooltip
							[tooltipLabel]="
								contact.refUserId !== null
									? ('CONTACT.OPEN_CHAT' | translate)
									: ('PAGES.CLIENTS.NO_CHAT' | translate)
							"
							tooltipPosition="right"
						>
							<span
								class="freud-icon freud-icon-message-circle"
								[ngClass]="{
									' freud-icon-message-circle--disabled':
										contact.refUserId === null
								}"
							></span>
						</button>
						<button
							(click)="scheduleAppointment(contact.id)"
							freud-tooltip
							[tooltipLabel]="'CONTACT.SCHEDULE' | translate"
							tooltipPosition="right"
						>
							<span class="freud-icon freud-icon-calendar-plus"></span>
						</button>
						<!-- <button>
							<span class="freud-icon freud-icon-archive"></span>
						</button> -->
						<button
							(click)="editContact(contact.id)"
							freud-tooltip
							[tooltipLabel]="'CONTACT.EDIT_PROFILE' | translate"
							tooltipPosition="right"
						>
							<span class="freud-icon freud-icon-edit"></span>
						</button>
					</div>
					<div class="table__actions--mobile">
						<contact-actions-mobile
							(onScheduleClick)="scheduleAppointment(contact.id)"
							(onEditClick)="editContact(contact.id)"
							(onChatClick)="contact.refUserId !== null && openChat(contact)"
						>
						</contact-actions-mobile>
					</div>
				</td>
			</tr>
		</ng-container>
		<ng-container *ngIf="contacts.length == 0">
			<tr class="tr--empty">
				<td colspan="5">
					<div class="table__empty">
						<img
							src="/assets/images/procurando.svg"
							alt="Zenklub mascot - looking for something ( empty table )"
							width="100px"
						/>
						<span class="zk-mt-5">{{ 'CONTACT.EMPTY' | translate }}</span>
						<span>{{ 'CONTACT.TRY_AGAIN' | translate }}</span>
					</div>
				</td>
			</tr>
		</ng-container>
	</tbody>
	<tbody class="tbody--loading" *ngIf="loading">
		<tr class="tr--loading">
			<td colspan="5">
				<freud-loader size="lg"></freud-loader>
			</td>
		</tr>
	</tbody>
</table>
